import { isOfferIsNotAvailableAnymoreError } from "@/app/lib/assertions";
import { GeneralPageError } from "@/app/ui/errors/GeneralPageError";
import { OfferNotAvailableError } from "@/app/ui/OfferNotAvailableError";

interface HotelOfferErrorProps {
  error: unknown;
}

export const HotelOfferError = ({ error }: HotelOfferErrorProps) => {
  if (error && isOfferIsNotAvailableAnymoreError(error)) {
    return <OfferNotAvailableError variant="hotel" />;
  }
  return (
    <GeneralPageError
      backOptions={{ to: "/", search: { category: "hotels" } }}
    />
  );
};
